import { Box, Container, Grid, Typography } from '@mui/material';

const StatisticsSection = () => {
    return (
        <Box
        sx={{
          pt: { xs: 16, md: 24 }, 
          pb: 6,
          background: 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)',
        }}
      >
      
            <Container maxWidth="lg">
                <Grid
                    container
                    spacing={4}
                    alignItems="center"
                    direction={{ xs: 'column', md: 'row' }}
                >
                    {/* Left: Text Content */}
                    <Grid item xs={12} md={7}>
                        <Box sx={{ maxWidth: 600 }}>
                            <Typography
                                variant="h4"
                                sx={{ fontWeight: 'bold', color: '#1e3c72', mb: 2, pb: 2 }}
                            >
                                Did You Know?
                            </Typography>

                            <Typography variant="body1" sx={{ mb: 3, color: '#333' }}>
                                One of the most effective ways to combat misinformation is to{" "}
                                <strong>pause before you share</strong>. Studies show that people often
                                spread false content impulsively. Taking just a few seconds to verify
                                a source or double-check the information can reduce the spread of
                                misinformation dramatically.
                            </Typography>

                            <Typography
                                variant="caption"
                                sx={{ display: 'block', mt: 2, color: '#666' }}
                            >
                                Source: MIT Sloan School of Management, 2021
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Right: Image */}
                    <Grid item xs={12} md={5}>
                    <Box
                        sx={{
                        display: 'flex',
                        justifyContent: { xs: 'center', md: 'flex-end' },
                        pl: 7, // center on mobile, right on desktop
                        }}
                    >
                        <Box
                        component="img"
                        src="images/group.jpeg"
                        alt="Young person verifying news on their phone"
                        sx={{
                            width: '100%',          // Take full width of the container
                            maxWidth: 400,          // Limit actual image size
                            borderRadius: 2,
                            boxShadow: 3,
                            mr: { xs: 0, md: 0 },   // Optional: add margin-right if needed
                        }}
                        />
                    </Box>
                    </Grid>

                </Grid>
            </Container>
        </Box>
    );
};

export default StatisticsSection;
//                             